import { Link } from 'react-router-dom'
import { SEO } from '@/components/layout/SEO'
import { Btn, SectionLabel, SectionTitle, Chevrons } from '@/components/ui'
import { C } from '@/constants/theme'
import { SERVICES, WA_URL } from '@/constants/data'
import { ServiceCard } from './Services'

const STATS = [
  { n: 'Same Day', label: 'Service Available' },
  { n: 'SABS', label: 'Approved Glass' },
]

const STEPS = [
  { step: '01', title: 'Damage',       desc: 'Call or send a message on WhatsApp, describe the damage and provide images.' },
  { step: '02', title: 'Book a Time',  desc: 'We confirm your preferred date and location.' },
  { step: '03', title: 'We Come to You', desc: 'Our team arrives at your home, office, or anywhere.' },
  { step: '04', title: 'Payment',      desc: 'Pay after the service is provided — your satisfaction is important.' },
]

export default function Home() {
  return (
    <>
      <SEO
        title="Auto Glass Specialists, Midrand"
        description="SABS-approved windscreen replacements, chip repairs & full auto glass services in Gauteng. Mobile service — we come to you. GlassTech Pty Ltd, Midrand."
        path="/"
      />

      {/* Hero */}
      <div style={{ background: 'linear-gradient(135deg, #F0F9FF 0%, #E8F4FC 50%, #F5F7FA 100%)', minHeight: '100vh', display: 'flex', alignItems: 'center', paddingTop: 68, position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', right: -80, top: '10%', width: 500, height: 500, borderRadius: '50%', background: 'radial-gradient(circle, rgba(0,174,239,0.08) 0%, transparent 70%)', pointerEvents: 'none' }} />
        <div style={{ position: 'absolute', right: 0, top: 0, bottom: 0, width: '42%', background: 'linear-gradient(135deg, transparent 0%, rgba(0,174,239,0.05) 100%)', clipPath: 'polygon(12% 0, 100% 0, 100% 100%, 0% 100%)', pointerEvents: 'none' }} />

        <div className="gt-hero-grid" style={{ maxWidth: 1200, margin: '0 auto', padding: '80px 24px', position: 'relative', zIndex: 1, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 48, alignItems: 'center' }}>
          <div>
            <SectionLabel text="Midrand, Gauteng" />
            <h1 style={{ fontFamily: "'Rajdhani', sans-serif", fontSize: 'clamp(40px, 6vw, 72px)', fontWeight: 700, color: C.text, lineHeight: 1.0, margin: '0 0 24px' }}>
              Auto Glass<br /><span style={{ color: C.blue }}>Experts</span><br />You Can Trust
            </h1>
            <p style={{ fontSize: 16, color: C.textMid, lineHeight: 1.8, maxWidth: 460, marginBottom: 36 }}>
              SABS-approved windscreen replacements, chip repairs & full auto glass services. We come to you — fast, affordable, done right.
            </p>
            <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap' }}>
              <a href={WA_URL} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}><Btn>Get a Free Quote</Btn></a>
              <Link to="/products" style={{ textDecoration: 'none' }}><Btn outline>Browse Products</Btn></Link>
            </div>
            <div style={{ display: 'flex', gap: 20, marginTop: 36, flexWrap: 'wrap' }}>
              {['✅ SABS Approved', '🚗 Mobile Service', '📋 Insurance Accepted'].map(b => (
                <div key={b} style={{ fontSize: 12, color: C.textMid, fontFamily: "'Rajdhani', sans-serif", fontWeight: 600, letterSpacing: 1 }}>{b}</div>
              ))}
            </div>
          </div>

          {/* Hero graphic */}
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <div style={{ position: 'relative', width: 360, height: 360 }}>
              <div style={{ position: 'absolute', inset: 0, borderRadius: '50%', background: 'radial-gradient(circle at 40% 40%, rgba(0,174,239,0.1), rgba(0,136,204,0.03))', border: '1px solid rgba(0,174,239,0.12)' }} />
              <div style={{ position: 'absolute', inset: 30, borderRadius: '50%', background: 'radial-gradient(circle at 40% 40%, rgba(0,174,239,0.06), transparent)', border: '1px solid rgba(0,174,239,0.08)' }} />
              <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <svg width="240" height="148" viewBox="0 0 120 72" fill="none">
                  <ellipse cx="42" cy="36" rx="38" ry="28" stroke="#ccc" strokeWidth="1.5" fill="white" />
                  <path d="M20 28 Q42 8 80 20 Q100 24 108 36" stroke="#aaa" strokeWidth="1.5" fill="none" />
                  <path d="M48 12 Q72 10 92 22 Q104 30 106 36" stroke={C.blue} strokeWidth="2.5" fill="none" />
                  <ellipse cx="52" cy="28" rx="16" ry="10" fill={C.blue} opacity="0.18" />
                  <path d="M108 36 L118 36" stroke="#aaa" strokeWidth="1.2" />
                  <path d="M112 34 L118 36 L112 38" fill="#aaa" />
                </svg>
              </div>
              {[{ label: 'SABS Approved', x: -30, y: 55 }, { label: 'Same Day', x: 255, y: 95 }, { label: 'Mobile Service', x: 30, y: 275 }].map(f => (
                <div key={f.label} style={{ position: 'absolute', left: f.x, top: f.y, background: C.white, border: `1px solid ${C.grayBorder}`, borderLeft: `3px solid ${C.blue}`, padding: '6px 12px', fontSize: 11, fontFamily: "'Rajdhani', sans-serif", fontWeight: 700, letterSpacing: 1, color: C.text, whiteSpace: 'nowrap', boxShadow: '0 4px 16px rgba(0,0,0,0.07)' }}>{f.label}</div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Stats */}
      <div style={{ background: C.blue, padding: '22px 24px' }}>
        <div style={{ maxWidth: 1200, margin: '0 auto', display: 'flex', justifyContent: 'center', gap: 80 }}>
          {STATS.map(s => (
            <div key={s.n} style={{ textAlign: 'center' }}>
              <div style={{ fontFamily: "'Rajdhani', sans-serif", fontSize: 28, fontWeight: 700, color: C.white }}>{s.n}</div>
              <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.75)', letterSpacing: 1.5, textTransform: 'uppercase' }}>{s.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Services */}
      <div style={{ background: C.white, padding: '80px 24px' }}>
        <div style={{ maxWidth: 1200, margin: '0 auto' }}>
          <SectionTitle label="What We Do" title="Our Services" sub="Professional auto glass solutions for all makes and models across Gauteng." />
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 24 }}>
            {SERVICES.map(s => <ServiceCard key={s.title} service={s} />)}
          </div>
        </div>
      </div>

      {/* How It Works */}
      <div style={{ background: C.grayLight, padding: '80px 24px' }}>
        <div style={{ maxWidth: 1200, margin: '0 auto' }}>
          <SectionTitle label="Process" title="How It Works" sub="Getting your glass sorted has never been easier." />
          <div className="gt-steps" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)' }}>
            {STEPS.map((item, i) => (
              <div key={i} style={{ padding: '36px 28px', background: C.white, border: `1px solid ${C.grayBorder}`, borderLeft: i > 0 ? 'none' : `1px solid ${C.grayBorder}`, position: 'relative' }}>
                <div style={{ fontFamily: "'Rajdhani', sans-serif", fontSize: 52, fontWeight: 700, color: C.blue, opacity: 0.12, lineHeight: 1, marginBottom: 8 }}>{item.step}</div>
                <div style={{ fontFamily: "'Rajdhani', sans-serif", fontSize: 18, fontWeight: 700, color: C.text, marginBottom: 8 }}>{item.title}</div>
                <div style={{ fontSize: 13, color: C.textMid, lineHeight: 1.7 }}>{item.desc}</div>
                {i < 3 && <div style={{ position: 'absolute', right: -12, top: '50%', transform: 'translateY(-50%)', width: 24, height: 24, background: C.blue, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: C.white, fontSize: 11, zIndex: 1, fontWeight: 700 }}>→</div>}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA */}
      <div style={{ background: `linear-gradient(135deg, ${C.text} 0%, #1a2f4a 100%)`, padding: '72px 24px', textAlign: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, marginBottom: 12 }}>
          <Chevrons opacity={0.5} />
          <span style={{ fontFamily: "'Rajdhani', sans-serif", fontSize: 11, letterSpacing: 4, color: C.blue, textTransform: 'uppercase' }}>Act Now</span>
        </div>
        <h2 style={{ fontFamily: "'Rajdhani', sans-serif", fontSize: 'clamp(26px, 4vw, 44px)', fontWeight: 700, color: C.white, margin: '0 0 12px' }}>Cracked Windscreen? Don't Wait.</h2>
        <p style={{ color: 'rgba(255,255,255,0.55)', fontSize: 15, marginBottom: 32, maxWidth: 420, margin: '0 auto 32px' }}>Chips spread fast. Get a free quote today — we'll come to you.</p>
        <div style={{ display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap' }}>
          <a href={WA_URL} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}><Btn>Get a Free Quote</Btn></a>
          <a href="tel:+27692145065" style={{ textDecoration: 'none' }}>
            <button style={{ padding: '13px 30px', fontFamily: "'Rajdhani', sans-serif", fontWeight: 700, fontSize: 14, letterSpacing: 1.5, textTransform: 'uppercase', background: 'transparent', color: C.white, border: '2px solid rgba(255,255,255,0.3)', cursor: 'pointer' }}>📞 +27 69 214 5065</button>
          </a>
        </div>
      </div>

      <style>{`
        @media (max-width: 900px) { .gt-hero-grid { grid-template-columns: 1fr !important; } }
        @media (max-width: 768px) { .gt-steps { grid-template-columns: 1fr 1fr !important; } }
        @media (max-width: 480px) { .gt-steps { grid-template-columns: 1fr !important; } }
        @media (max-width: 600px) { [style*="repeat(4, 1fr)"] { grid-template-columns: repeat(2, 1fr) !important; } }
      `}</style>
    </>
  )
}
